
const Geo = {
    DEFAULT_COUNTRY: 1,
    COUNTRY_ISRAEL: 24,
};

export default Geo;



// WEBPACK FOOTER //
// ./client/constants/Geo.js